import PropTypes from 'prop-types'

import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'
import SignedOutForm, {
  SignedOutFormContainer,
  UpperBackText
} from 'components/authentication/SignedOutForm'

export default function MFAForm({
  token,
  submitting,
  handleBack,
  handleTokenChange,
  handleTokenSubmission
}) {
  return (
    <SignedOutFormContainer>
      <UpperBackText onClick={handleBack}>Back to login</UpperBackText>
      <SignedOutForm
        title="Enter your MFA token"
        onSubmit={event => {
          event.preventDefault()
          handleTokenSubmission()
        }}
      >
        <InputTextField
          data-test-mfa-token-input
          disabled={submitting}
          label="MFA Token"
          name="token"
          value={token}
          onChange={event => handleTokenChange(event.target.value)}
        />
        <Button
          data-test-mfa-continue-button
          primary
          stretch
          disabled={submitting}
          type="submit"
        >
          Continue
        </Button>
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}

MFAForm.propTypes = {
  token: PropTypes.string.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleTokenChange: PropTypes.func.isRequired,
  handleTokenSubmission: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}
